import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import Button from './Button.js';

const Pagination = ({ currentPage, totalPages, onPageChange, className = '' }) => {
  if (!totalPages || totalPages <= 1) return null;

  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;
    let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
    let end = Math.min(totalPages, start + maxVisible - 1);

    if (end - start + 1 < maxVisible) {
      start = Math.max(1, end - maxVisible + 1);
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  };

  return (
    <div className={`flex items-center justify-center gap-1 sm:gap-2 py-4 ${className}`}>
      <Button
        variant="outline"
        size="sm"
        icon={ChevronLeft}
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage <= 1}
        aria-label="Previous page"
      />

      {getPageNumbers().map((page) => (
        <button
          key={page}
          onClick={() => onPageChange(page)}
          className={`
            min-w-[36px] h-9 px-3 rounded-btn text-sm font-medium transition-all duration-200
            ${page === currentPage
              ? 'bg-buttonBg text-white shadow-sm'
              : 'bg-white text-secondary border border-gray-200 hover:bg-gray-50'}
          `}
        >
          {page}
        </button>
      ))}

      <Button
        variant="outline"
        size="sm"
        icon={ChevronRight}
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage >= totalPages}
        aria-label="Next page"
      />
    </div>
  );
};

export default Pagination;
